import { createAction, Action } from 'redux-actions';

export const actionTypes = {
  SET_INTERNAL_SERVER_ERROR_DIALOG_VISIBLE: 'SET_INTERNAL_SERVER_ERROR_DIALOG_VISIBLE',
};

export const setInternalServerErrorDialogVisible: (payload: boolean) => Action<boolean> = createAction(
  actionTypes.SET_INTERNAL_SERVER_ERROR_DIALOG_VISIBLE
);
